import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddjee7w2j5: FaireProductEntity = {
  token: "p_ddjee7w2j5",
  type: "product",
  name: "Cinnamoroll Sanrio Decoration Building Set",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/97cccd561a697b14d5f639f8457af174dc547e9b5f482c71385f33d77072595b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23887f3a84038d5b147e914a87fbd2bc4a1bcbcc9c6abf0b98310aacf8e493af.jpeg",
    "https://cdn.faire.com/fastly/14ca74630e2fd7202ae8746d33c0430b3173cd420eed4664efdadead2ed47bcc.jpeg",
    "https://cdn.faire.com/fastly/6f0687fab44c8e237d1b36bff8fddc0948f8d669a0775c66313ab783da52bc86.jpeg",
    "https://cdn.faire.com/fastly/e1d1279c349c61ef604e088da63b5c1acc4eb115687edcf8740c2175ed91f110.jpeg",
    "https://cdn.faire.com/fastly/55c31bac675bf65520598588a8dfd6c48dc31dfcf7ee890d2d2d508c07357fed.jpeg",
    "https://cdn.faire.com/fastly/e07e1067a667dbbed895eac2658c4d0574f4df1f699d3a6d4e4dcdc9981d1c39.jpeg",
    "https://cdn.faire.com/fastly/2e537f133bb393b3b70d8ef1e4fe14e47aaf5d45bf7c6c3a75f5926d9ceee728.jpeg",
  ],
  priceDollars: 7.58,
  description:
    "Cinnamoroll gets festive in this brick-built holiday decoration, complete with his floppy ears, cheerful smile, and bright blue eyes. A tall green-and-red holiday hat and striped scarf add seasonal flair, while the included stand and hanging string give you versatile ways to display him. With colorful details and a playful design, this quick build makes a charming addition to holiday décor and a sweet collectible for Sanrio fans.",
  tags: [],
  msrpDollars: 15.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:57.418Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
